<template>
  <div id="AccountScheduledReportsRuns" class="Main-Content">

    <Page
      :title="$t('scheduledReports.generatedReports')"
      :breadcrumbs="[
          {
            label: $t('Back to list'),
            onAction: () => backToList()
          }
        ]"
      fullWidth
    >
      <LoadingLayout v-if="loading"/>
      <Layout v-if="!loading">
        <LayoutSection>
          <Card>
            <Filters
              :filters="[
                {
                  key: 'reportId',
                  label: this.$t('scheduledReports.report'),
                  type: 'select',
                  placeholder: this.$t('scheduledReports.chooseReport'),
                  options: reports
                }
              ]"
              :query.sync="query"
              :applied-filters="appliedFilters"
              @update:applied-filters="setAppliedFilters"
              @update:query="setQuery"
            />
            <DataTable
              :columns="[
                {
                  key: 'url',
                  label: $t('scheduledReports.fileName')
                },
                {
                  key: 'status',
                  label: $t('Status')
                },
                {
                  key: 'createdOn',
                  label: $t('scheduledReports.runDate'),
                  format: 'dateLong'
                }
              ]"
              :rows="formattedRuns"
              :row-actions="(row) => getRowActions(row)"
              :loading="loading"
              :pagination="{
                offset: offset,
                limit: limit,
                total: formattedRuns.length,
                updateOffset: updateOffset,
                updateLimit: updateLimit
              }"
            >
              <!-- <template v-slot:col:name="{row}">
                <PageLink :href="getReportUrl(row.id)">{{row.name}}</PageLink>
              </template> -->
            </DataTable>
          </Card>
        </LayoutSection>
      </Layout>

    </Page>

  </div>
</template>

<script>
// import _ from 'lodash'
export default {
  name: 'AccountScheduledReportsRuns',
  data () {
    return {
      loading: true,
      saving: false,
      runs: [],
      reports: [],
      query: '',
      appliedFilters: {
        reportId: null
      },
      offset: 0,
      limit: 10
    }
  },
  async mounted() {
    await this.setFilterFromQuery()

    this.$watch('$route', async () => {
      await this.setFilterFromQuery()
    }, { deep: true })

    NProgress.start()
    this.limit = this.getTableLimit('tableLimit') || 10
    Promise.all([
      this.api.getScheduledReports(),
      this.api.getScheduledReportRuns()
    ])
      .then((data) => {
        const [reports, runs] = data
        this.reports = (reports || []).map(r => {
          return {
            label: r.name,
            description: r.status === 'enabled' ? this.$t('Enabled') : this.$t('Disabled'),
            value: r.id
          }
        })
        this.runs = runs || []
      })
      .catch(this.apiCatch)
      .finally(() => {
        this.loading = false
        NProgress.done()
      })
  },
  computed: {
    formattedRuns() {
      return this.runs.filter(r => {
        if (this.appliedFilters.reportId) {
          return r.typeId === this.appliedFilters.reportId
        }
        return true
      }).filter(r => {
        if (this.query) {
          return JSON.stringify(r).toLowerCase().includes(this.query.trim().toLowerCase())
        }
        return true
      }).map(r => {
        const urlSections = r.url && r.url.split('/') || []
        const url = urlSections.length && urlSections[urlSections.length - 1] || ''
        return {
          ...r,
          url
        } 
      })
    }
  },
  methods: {
    backToList() {
      this.$router.push({ name: 'AccountScheduledReportsList' })
    },
    getRowActions(row) {
      const rv = [
        {
          label: 'Download',
          onAction: () => this.download(row.id)
        }
      ]
      return rv
    },
    download(id) {
      NProgress.start()
      this.exporting = true
      this.api.getDownloadSignedUrl(id)
      .then((url) => {
        window.open(url)
      })
      .catch(this.apiCatch)
      .finally(() => {
        this.exporting = false
        NProgress.done()
      })
    },
    updateLimit(limit) {
      this.setTableLimit('tableLimit', limit)
      this.limit = limit
      this.offset = 0
    },
    updateOffset(offset) {
      this.offset = offset
    },
    resetPagination() {
      this.offset = 0
    },
    setQuery(query) {
      this.query = query
      this.resetPagination()
    },
    setAppliedFilters(filters) {
      this.appliedFilters = filters
      this.resetPagination()
      this.updateUrl()
    },
    updateUrl() {
      this.$router.push({ name: 'AccountScheduledReportsRuns', query: this.appliedFilters })
      .catch(this.duplicateRouteCatch)
    },
    async setFilterFromQuery() {
      if (this.$route.query) {
        this.appliedFilters = {}
        Object.keys(this.$route.query).forEach((k) => {
          if (this.$route.query[k] && k === 'reportId') {
            this.appliedFilters[k] = parseInt(this.$route.query[k])
          } else {
            this.appliedFilters[k] = null
          }
        })
      }

      await this.$router.replace({ name: 'AccountScheduledReportsRuns', query: this.appliedFilters })
      .catch(this.duplicateRouteCatch)
    }
  }
}

</script>
